import React from 'react'
import { Link } from 'react-router-dom/cjs/react-router-dom.min'

export const Banner = ({ b }) => {
    return (
        <Link
            key={b.id}
            to={b?.url??""}
            className="block rounded-lg overflow-hidden shadow relative"
        >
            <div className='absolute top-5 left-3 lg:top-20 lg:left-10 w-[60%] lg:w-[50%] flex flex-col gap-2 items-start'>
                <h4 className=''>{b?.title}</h4>
                <p className='font-bold lg:text-2xl'>{b?.describe}</p>
                <button className='bg-[--color-button-3] w-auto px-4 py-1 rounded-full text-white text-sm font-bold 
                    hover:bg-[--color-button-2] hover:text-black transition-all duration-200
                '>{b?.action?.title}</button>
            </div>
            <img
                src={b.image}
                alt={`Banner ${b.id}`}
                className="w-full h-[150px] lg:h-auto object-cover"
            />
        </Link>
    )
}
